import { hooks } from '@/store.js';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import showErrMessage from '@/utils/showErrMessage.js';
import { Checkbox, Form } from '@heroui/react';
import { useMemoizedFn, useRequest } from 'ahooks';
import { memo, useState } from 'react';
import isEqual from 'react-fast-compare';
import { toast } from 'sonner';

import SheetWrapper, { SheetWrapperHeader } from '../SheetWrapper/index.jsx';
import { planDetailEvent } from '@/pages/PlanDetail/utils/event.js';
import NavList from '@/pages/PlanDetail/comps/NavList/index.jsx';
import usePlanDetailScroll from '@/pages/PlanDetail/hooks/usePlanDetailScroll.js';
import usePlanDetailData from '@/pages/PlanDetail/hooks/usePlanDetailData.js';
import { VList } from 'virtua';
import usePlanList from '@/pages/PlanDetail/hooks/usePlanList.js';
import type { IListItem } from '@/pages/PlanDetail/interface.js';

interface IProps {
  onClose: () => void;
  planId: string;
  onSubmit: (payload?: string[]) => void;
  defaultValue?: string[];
}

const Item = memo(
  ({
    item,
    checked,
    onCheck,
  }: {
    item: IListItem;
    checked: boolean;
    onCheck: (payload: boolean) => void;
  }) => {
    const { type, props, key } = item;

    if (type === 'Transfer' || type === 'Add') return null;
    if (type === 'DayTitle') {
      return (
        <header className='text-2xl py-1 text-gray-800 font-bold'>
          DAY {Number(key.split('-').slice(3)) + 1}
        </header>
      );
    }

    if (type === 'Divider') {
      return <div className='border-b border-gray-100 mt-4 mb-2' />;
    }

    let title: string = type;
    let icon = '';
    if (type === 'AirPlane') {
      title = `${props.no}`;
      icon = 'ic-outline md-flight';
    }

    return (
      <article
        className='bg-white  my-1 rounded-xl shadow-12-light px-4 py-2 flex items-center'
        onClick={() => {
          onCheck(!checked);
        }}
      >
        <Checkbox
          // @ts-ignore type
          radius='full'
          className={`${checked ? '' : ' opacity-40'} mr-0.5`}
          isSelected={checked}
          onValueChange={onCheck}
        />
        <i
          className={`w-8 h-8 text-gray-800 ${icon} block rounded-lg mr-2 leading-8 text-center bg-gray-100/80 `}
        />
        <span className='font-semibold text-gray-800'>{title}</span>
      </article>
    );
  },
  isEqual
);

const Inner = memo(({ onClose, planId, onSubmit, defaultValue }: IProps) => {
  const { startTime, endTime } = usePlanDetailData(planId, {});

  const { date, onPlanDetailLoaded, navListProps, scrollContainerProps } =
    usePlanDetailScroll({ startTime, endTime });
  const { list } = usePlanList({
    date,
    id: planId,
    onLoaded: onPlanDetailLoaded,
  });
  const [selectedKeys, setSelectedKeys] = useState<string[]>(
    defaultValue || []
  );

  return (
    <Form
      className='w-full !block pb-safe '
      validationBehavior='native'
      onSubmit={(e) => {
        e.stopPropagation();
        e.preventDefault();
        // const data = Object.fromEntries(new FormData(e.currentTarget));

        // STEP: 创建记录
        // runAsync(data);

        onSubmit(selectedKeys);
        onClose();
      }}
    >
      {/* <AddFormHeader onClose={onClose} loading={loading} /> */}

      <SheetWrapperHeader
        title='选择活动'
        // align='left'
      />

      <div className=' pt-4 pb-10'>
        <NavList {...navListProps} size='sm' display='no' />
        <VList
          style={{ minHeight: '40vh' }}
          className='px-5'
          {...scrollContainerProps}
        >
          {list?.map((i) => {
            const checked = selectedKeys.includes(i.props.id);
            return (
              <Item
                key={i.key}
                item={i}
                checked={checked}
                onCheck={() => {
                  setSelectedKeys((prev) => {
                    // if (prev.includes(i.props.id)) {
                    //   return prev.filter((n) => n !== i.props.id);
                    // }
                    // return [...prev, i.props.id];
                    return [i.props.id];
                  });
                }}
              />
            );
          })}
        </VList>
      </div>
    </Form>
  );
}, isEqual);

const Modal = NiceModal.create((props: IProps) => {
  const [closeKey, setCloseKey] = useState(0);
  return (
    <SheetWrapper closeKey={closeKey}>
      <Inner {...props} onClose={() => setCloseKey(+new Date())} />
    </SheetWrapper>
  );
});

export const useEventSelect = () => {
  const modal = useModal(Modal);
  return {
    show: modal.show,
  };
};
